const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const bulkUpdateLeadsApi = async (updateData) => {
    const token = localStorage.getItem('token');
    
    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    const formData = new FormData();
    

    for (const key in updateData) {
        const value = updateData[key];
        
        if (key === 'lead_ids' && Array.isArray(value)) {
            if (value.length === 0) {
                 formData.append('lead_ids[]', ''); 
            } else {
                value.forEach(id => formData.append('lead_ids[]', id));
            }
        } else if (value !== null && value !== undefined) {
            formData.append(key, value);
        }
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/bulk-update`, 
            {
                method: 'POST', 
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                    'X-HTTP-Method-Override': 'PATCH' 
                },
                body: formData,
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            console.error('[bulkUpdateLeadsApi] Ошибка обновления лидов:', errorData);
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось обновить лиды.`);
        }
        

        return true; 
        
    } catch (error) {
        console.error("Ошибка сети или другая ошибка при массовом обновлении лидов:", error);
        throw error;
    }
};